import React, { createContext, useContext } from 'react';

/**
 * Portal host for tab-scoped overlays (Mission Full View, DocSheet, VariablesPanel).
 * Host is the `.app-main` element so overlays track sidebar/brain geometry.
 */
const AppMainOverlayContext = createContext(null);

export function AppMainOverlayProvider({ host, children }) {
  return (
    <AppMainOverlayContext.Provider value={host}>
      {children}
    </AppMainOverlayContext.Provider>
  );
}

export function useAppMainOverlayHost() {
  return useContext(AppMainOverlayContext);
}

export default AppMainOverlayContext;
